import React, {ReactElement} from 'react';
import {ProvisionedAppConfig} from "../shared/types";
import "../res/css/App.css";
import {PathComponent} from "../index";
import {PeppinApp} from "./app-shared/common/PeppinApp";
import {Main} from "./Main";
import {FirebaseOptions} from "firebase/app";
import {Settings} from "./settings";
import {User} from "@firebase/auth";

const FIREBASE_OPTIONS: FirebaseOptions = {
  apiKey: "AIzaSyCFGqIN8ZFN6Q4D09hxgVuybLSdh716wuM",
  authDomain: "peppin-apps.firebaseapp.com",
  databaseURL: "https://peppin-apps-default-rtdb.firebaseio.com",
  projectId: "peppin-apps",
  storageBucket: "peppin-apps.firebasestorage.app",
  messagingSenderId: "100967362599",
  appId: "1:100967362599:web:e9d59b614130367de85e02",
  measurementId: "G-JZXKTGCE2S"
};

export class AppRefs {

  constructor(readonly audio: HTMLAudioElement) {
  }
}

export class App extends PeppinApp {

  private static appRefs: AppRefs;

  static getAppRefs(): AppRefs {
    if (!App.appRefs) {
      App.appRefs = App.createAppRefs();
    }
    return App.appRefs;
  }

  private static createAppRefs() {
    return new AppRefs(document.getElementById("player") as HTMLAudioElement);
  }

  protected getAppName(): string {
    return "Showcase";
  }

  getProvisionedAppId(): string {
    return "showcase";
  }

  getProvisionedAppConfig(): ProvisionedAppConfig | null {
    return null;
  }

  protected async onAppInitWithLoggedInUser(user: User): Promise<void> {
    await super.onAppInitWithLoggedInUser(user);
    await Settings.loadInstance();
  }

  protected getFirebaseOptions(): FirebaseOptions {
    return FIREBASE_OPTIONS;
  }

  static nestedPaths(): PathComponent[] {
    return Main.nestedPaths();
  }

  protected renderMain(): ReactElement {
    return <Main path={this.props.path}/>;
  }
}
